<div
  class="file-upload-wrapper"
  (drop)="onDrop($event)"
  (dragover)="onDragOver($event)"
  [class.disabled]="disabled()">
  <input
    #fileInput
    type="file"
    hidden
    [accept]="accept()"
    [multiple]="multiple()"
    (change)="onFileChange($event)" />
  <div class="file-dropper">
    <div class="bi bi-cloud-upload fs-1 text-primary"></div>
    <p class="mb-1 fw-medium">{{ title() }}</p>
    <p class="small text-muted mb-3">{{ subtitle() }}</p>
    <button type="button" class="btn btn-primary" (click)="openPicker()" [disabled]="disabled()">
      @if (disabled()) {
        Working…
      } @else {
        Browse files
      }
    </button>
  </div>
</div>
